import { useContext, useEffect, useState } from 'react';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import listItemDefaultStyle from './listItemDefaultStyle';
import { clsx } from 'clsx';
import { ListContext } from '../List/ListContext';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ListItemContainer = props => {
  const {
    children,
    className,
    id,
    onClick,
    selected,
    selectable,
    index,
    sx,
    ...rest
  } = props;
  const [isSelected, setIsSelected] = useState(false);
  const context = useContext(ListContext);
  const theme = useInterstateTheme();
  const listItemStyle = mergeSxStyle(listItemDefaultStyle(theme, selectable), sx);
  useEffect(() => {
    setIsSelected(id === context || index === context);
  }, [context]);
  return /*#__PURE__*/_jsxs(Box, {
    id: id,
    component: "div",
    onClick: onClick,
    "data-testid": rest['data-testid'],
    sx: listItemStyle,
    className: clsx(['ids-list-group-item', isSelected ? 'ids-list-group-item-selected' : undefined]),
    children: [isSelected && /*#__PURE__*/_jsx(Box, {
      className: "ids-list-item-content-selected"
    }), /*#__PURE__*/_jsx(Box, {
      className: 'ids-list-item-content',
      children: children
    })]
  });
};
ListItemContainer.displayName = 'ListItemContainer';